import { useEffect } from "react"

export function useFastTypewriter(typedElementRef, setShowTagline) {
  useEffect(() => {
    const phrases = [
      "AI-driven Workflows",
      "Advanced Automation",
      "Enterprise-grade Intelligence",
      "Custom Digital Solutions",
    ]
    let phraseIndex = 0
    let animationFrame
    const totalTypingTime = 500 // typing duration in ms
    const totalDeletingTime = 500
    let isMounted = true

    const typePhrase = (phrase, cb) => {
      let start = null
      const update = (timestamp) => {
        if (!start) start = timestamp
        const elapsed = timestamp - start
        const progress = Math.min(elapsed / totalTypingTime, 1)
        const charCount = Math.floor(phrase.length * progress)
        if (typedElementRef.current) {
          typedElementRef.current.textContent = phrase.slice(0, charCount)
        }
        if (progress < 1) {
          animationFrame = requestAnimationFrame(update)
        } else {
          cb()
        }
      }
      animationFrame = requestAnimationFrame(update)
    }

    const deletePhrase = (phrase, cb) => {
      let start = null
      const update = (timestamp) => {
        if (!start) start = timestamp
        const elapsed = timestamp - start
        const progress = Math.min(elapsed / totalDeletingTime, 1)
        const charCount = phrase.length - Math.floor(phrase.length * progress)
        if (typedElementRef.current) {
          typedElementRef.current.textContent = phrase.slice(0, charCount)
        }
        if (progress < 1) {
          animationFrame = requestAnimationFrame(update)
        } else {
          cb()
        }
      }
      animationFrame = requestAnimationFrame(update)
    }

    const cyclePhrases = () => {
      if (!isMounted || !typedElementRef.current) return
      const currentPhrase = phrases[phraseIndex]
      typePhrase(currentPhrase, () => {
        setTimeout(() => {
          deletePhrase(currentPhrase, () => {
            phraseIndex = (phraseIndex + 1) % phrases.length
            cyclePhrases()
          })
        }, 1000)
      })
    }

    cyclePhrases()
    setShowTagline(true)

    return () => {
      isMounted = false
      cancelAnimationFrame(animationFrame)
    }
  }, [typedElementRef, setShowTagline])
}
